(() => {
  if (customElements.get('aotr-product-description')) return;
  class AotrProductDescription extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('p').forEach(paragraph => {
        const text = paragraph.textContent.replace(/\u00a0/g, ' ').trim();
        const media = paragraph.querySelector('a, img, picture, video, audio, iframe, svg, canvas, object, embed, button, input, select, textarea, hr, [id], [name]');
        if (!text && !media && !paragraph.id) {
          paragraph.hidden = true;
          paragraph.setAttribute('data-aotr-empty-paragraph', '');
        }
      });
    }
  }
  customElements.define('aotr-product-description', AotrProductDescription);
})();
